import { Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import { UploadType, UploadModalConfig } from '@app/shared/components/upload-modal/models/upload-modal-config'
import { FileErrorTypeEnum, UploadModalService } from '../services/upload-modal.service'

@Component({
  selector: 'upload-modal-validation',
  templateUrl: './upload-modal-validation.component.html',
  styleUrls: ['../upload-modal.component.scss'],
  providers: [UploadModalService],
})
export class UploadModalValidationComponent {
  verifiedFile = false

  @ViewChild('uploader') uploader: ElementRef

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UploadModalConfig,
    public dialog: MatDialog,
    protected uploadModalService: UploadModalService
  ) {
    uploadModalService.setModalConfig(data)
  }

  uploadFile($event: any) {
    this.uploadModalService.uploadFile($event)
    this.verifiedFile = false
  }

  validateExcelFile() {
    if (this.uploadModalService.file) {
      const fileName = this.uploadModalService.file.name
      const fileExt = fileName.split('.').pop().toLowerCase()
      this.uploadModalService.errors = []

      if (fileExt.toLowerCase() === 'xlsx') {
        if (!this.uploadModalService.uploading) {
          this.uploadModalService.uploading = true
          this.verifiedFile = false

          this.data.verifyService
            .verify(this.uploadModalService.file, this.data.type, this.data.includeRoleAndHour)
            .subscribe({
              next: (context: any) => {
                if (context?.byteLength > 0) {
                  const blob = new Blob([context], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  })
                  const url = window.URL.createObjectURL(blob)
                  window.open(url, '_self', '')
                  this.uploadModalService.showErrorList = true
                  this.uploadModalService.uploading = false
                  this.uploader.nativeElement.value(null)
                } else {
                  this.verifiedFile = true
                  this.uploadModalService.uploading = false
                }
              },
              error: (error) => {
                if (error.status == 409) {
                  this.uploadModalService.showErrorList = true
                  this.uploadModalService.errors.push({ errorType: FileErrorTypeEnum.SEE_ERRORS })
                  const blob = new Blob([error.error], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  })
                  const originalFile = this.uploadModalService.file.name
                  let verifiedFileName = 'Verified_'
                  const dateFormat = new Date()
                    .toISOString()
                    .slice(0, 16)
                    .replace('T', '_')
                    .replace(':', '')
                    .replaceAll('-', '')
                  verifiedFileName = verifiedFileName.concat(dateFormat, '-', originalFile)
                  this.uploadModalService.fileName = verifiedFileName
                  this.uploadModalService.fileUrl = window.URL.createObjectURL(blob)
                } else {
                  this.uploadModalService.errors.push({ errorType: FileErrorTypeEnum.FILE_NOT_CORRECT })
                }

                this.verifiedFile = true
                this.uploadModalService.uploading = false
              },
            })
        }
      } else {
        this.uploadModalService.errors = []
        this.uploadModalService.errors.push({ errorType: FileErrorTypeEnum.FILE_NOT_CORRECT })
      }
    }
  }

  downloadConflictedFile() {
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = this.uploadModalService.fileUrl
    a.download = this.uploadModalService.fileName
    a.click()
  }

  protected readonly UploadType = UploadType
}
